
import React from 'react';
import { Home, Phone, Mail, Instagram, Facebook, Linkedin, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

// Custom TikTok icon since Lucide might not have it in this version or to be safe
const TikTokIcon = ({ size = 18 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const Footer: React.FC = () => {
  return (
    <footer className="bg-navy text-white pt-12 pb-6 relative z-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Home className="text-orange" size={24} />
              <span className="text-2xl font-bold">LDF</span>
            </div>
            <p className="text-gray-300 text-sm mb-4">
              La marketplace immobilière de référence au Bénin. Nous facilitons la rencontre entre propriétaires et chercheurs de biens en toute sécurité.
            </p>
            <div className="flex space-x-3">
                <a href="https://www.facebook.com/share/1Exxxhsi3D/" target="_blank" rel="noreferrer" className="bg-white/10 p-2 rounded-full hover:bg-[#1877F2] transition"><Facebook size={18} /></a>
                <a href="https://www.instagram.com/le.demarcheur.facilitateur?igsh=MTJhcW1weG5idjZzdw==" target="_blank" rel="noreferrer" className="bg-white/10 p-2 rounded-full hover:bg-[#E4405F] transition"><Instagram size={18} /></a>
                <a href="https://www.linkedin.com/company/ledemarcheur-facilitateur/?viewAsMember=true" target="_blank" rel="noreferrer" className="bg-white/10 p-2 rounded-full hover:bg-[#0A66C2] transition"><Linkedin size={18} /></a>
                <a href="https://www.tiktok.com/@ldfdiaspora?_r=1&_t=ZM-91kDkbTJYj5" target="_blank" rel="noreferrer" className="bg-white/10 p-2 rounded-full hover:bg-black transition"><TikTokIcon size={18} /></a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-orange">Navigation</h3>
            <ul className="space-y-2 text-gray-300">
              <li><Link to="/" className="hover:text-white transition">Accueil</Link></li>
              <li><Link to="/nos-biens" className="hover:text-white transition">Nos Biens</Link></li>
              <li><Link to="/nos-services" className="hover:text-white transition">Nos Services</Link></li>
              <li><Link to="/qui-nous-sommes" className="hover:text-white transition">Qui nous sommes ?</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-orange">Contactez-nous</h3>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center group">
                 <div className="bg-white/10 p-2 rounded-full mr-3 group-hover:bg-orange transition">
                    <Mail size={16} className="text-white" />
                </div>
                <a href="mailto:ledemarcheur@lefacilitateur.online" className="hover:text-orange break-all">ledemarcheur@lefacilitateur.online</a>
              </li>
              <li className="flex items-center group">
                <div className="bg-white/10 p-2 rounded-full mr-3 group-hover:bg-orange transition">
                    <Phone size={16} className="text-white" />
                </div>
                <span>+229 01 97 40 67 67</span>
              </li>
              <li className="flex items-center group">
                <div className="bg-white/10 p-2 rounded-full mr-3 group-hover:bg-[#25D366] transition">
                    <MessageCircle size={16} className="text-white" />
                </div>
                <span>+229 97 40 67 67</span>
              </li>
              <li className="flex items-center">
                 <div className="bg-white/10 p-2 rounded-full mr-3">
                    <Home size={16} className="text-white" />
                </div>
                <span>Cotonou, Bénin</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-6 text-center text-sm text-gray-400 flex flex-col md:flex-row justify-between items-center">
          <span>&copy; {new Date().getFullYear()} Le Démarcheur Facilitateur.</span>
          <div className="flex space-x-4 mt-2 md:mt-0">
              <Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link>
              <Link to="/confidentialite" className="hover:text-white">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
